import { useContext, createContext } from "react";

export const AppContext = createContext(null);

export function useAppContext({...props} = {}) {
  return useContext(AppContext) || {...props};
}
